import { render, staticRenderFns } from "./CrmReports.vue?vue&type=template&id=44a7247e&scoped=true"
import script from "./CrmReports.vue?vue&type=script&lang=js"
export * from "./CrmReports.vue?vue&type=script&lang=js"
import style0 from "./CrmReports.vue?vue&type=style&index=0&id=44a7247e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a7247e",
  null
  
)

export default component.exports